import { Page } from '../../types/Types';
import ActionTypes from '../Action.types';

type State = {
  pages: Page[];
  isLoading: boolean;
  errMessage: string;
};

type Action = {
  type: string;
  payload: any;
};
const FacebookPageReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionTypes.start:
      return { ...state, isLoading: true };
    // ------------------------------------------------------------------- //
    // ----------------------------- FIND ALL----------------------------- //
    // ------------------------------------------------------------------- //
    case ActionTypes.find:
      let getData: Page[] = action.payload.sort(
        (a: Page, b: Page) =>
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
      );

      getData = getData.map((d: any) => {
        return {
          ...d,
          id: d._id,
          type: d.type ? d.type : '',
          status: d.status,
          createdAt: new Date(d.createdAt).toLocaleDateString('en-EN'),
          updatedAt: new Date(d.updatedAt).toLocaleDateString('en-EN'),
        };
      });
      return { ...state, isLoading: false, pages: getData };
    // ------------------------------------------------------------------ //
    // ----------------------------- UPLOAD ----------------------------- //
    // ------------------------------------------------------------------ //
    case ActionTypes.upload:
      let uploadPages: any = [...state.pages];
      action.payload.map((data: any) => uploadPages.push(data));
      return { ...state, isLoading: false, pages: uploadPages };
    // ----------------------------------------------------------------------- //
    // ----------------------------- UPDATE----- ----------------------------- //
    // ----------------------------------------------------------------------- //
    case ActionTypes.update:
      return {
        ...state,
        isLoading: false,
        pages: state.pages.map((page) =>
          page.id === action.payload._id
            ? {
                ...action.payload,
                id: action.payload._id,
                status: action.payload.status,
                createdAt: new Date(
                  action.payload.createdAt
                ).toLocaleDateString('en-EN'),
                updatedAt: new Date(
                  action.payload.updatedAt
                ).toLocaleDateString('en-EN'),
              }
            : page
        ),
      };
    // ----------------------------------------------------------------------- //
    // ----------------------------- UPDATE MANY ----------------------------- //
    // ----------------------------------------------------------------------- //
    case ActionTypes.update_many:
      let editedMany: any = [];
      editedMany = state.pages.map((page) => {
        if (action.payload.itemsId.includes(page.id)) {
          return {
            ...page,
            status: action.payload.editData.status
              ? action.payload.editData.status
              : page.status,
            updatedAt: new Date().toLocaleDateString('en-EN'),
            updatedBy: action.payload.editData.updatedBy,
          };
        }
        return page;
      });
      return { ...state, isLoading: false, pages: editedMany };

    case 'EDIT_STOCK_AGENT':
      let editAgent: any = [];
      editAgent = state.pages.map((page) => {
        if (action.payload.itemsId.includes(page.id)) {
          return {
            ...page,
            agent: action.payload.editData.agent,
          };
        }
        return page;
      });
      return { ...state, isLoading: false, pages: editAgent };

    // ------------------------------------------------------------------ //
    // ----------------------------- DELETE ----------------------------- //
    // ------------------------------------------------------------------ //
    case ActionTypes.delete:
      return {
        ...state,
        isLoading: false,
        pages: state.pages.filter((page) => page.id !== action.payload),
      };
    // ----------------------------------------------------------------------- //
    // ----------------------------- DELETE MANY ----------------------------- //
    // ---------------------------------------------------------------------- //
    case ActionTypes.delete_many:
      return {
        ...state,
        isLoading: false,
        pages: state.pages.filter(
          (page: any) => !action.payload.includes(page.id)
        ),
      };
    default:
      return state;
  }
};

export default FacebookPageReducer;
